import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppNotificationService } from '../../services/app-notification.service';
import * as appNotificationsActions from '../actions/app-notification.action';


@Injectable()
export class AppNotificationEffect {
  
  public fetchNotifications: Observable<Action> = createEffect(() => this._actions.pipe(
    ofType(appNotificationsActions.AppNotificationInitialFetch),
    switchMap(() => {
        return this._appNotificationService.fetchNotifications().pipe(
          map(response => appNotificationsActions.AppNotificationInitialFetchSucceed({ response }))
        )
    })
  ));
 
  
  public clearAllNotifications: Observable<Action> = createEffect(() => this._actions.pipe(
    ofType(appNotificationsActions.AppNotificationClearAll),
    switchMap(() => {
        return this._appNotificationService.clearAllNotifications().pipe(
          map(resp => appNotificationsActions.AppNotificationClearAllSucceed())
        )
    })
  ));

  constructor(
    private readonly _actions: Actions,
    private readonly _appNotificationService: AppNotificationService,
  ) {
  }
}
